import { cn } from "../lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "tw-figr-animate-pulse tw-figr-rounded-m tw-figr-bg-neutral-200",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
